import * as React from 'react';

import { MessageCircleIcon } from '@/imports/ui/chakra/feather';

import { RespondButton } from '../../RespondButton';

export const CommentButton: React.FC<{ onClick?: () => void }> = ({
  onClick,
}) => {
  return (
    <RespondButton
      leftIcon={<MessageCircleIcon />}
      onClick={onClick}
      color="gray.600"
    >
      Comment
    </RespondButton>
  );
};
